import { route, subGroup, meta } from '@/helpers/routes'

import DashboardProfessional from './gadget/index'
const routes = [
  route('index', '/index', DashboardProfessional, meta('Dashboard Cliente', true, 'guest'))
]

export default subGroup('/dashboard', routes)



// WEBPACK FOOTER //
// ./src/app/dweller/dashboard/routes.js